import { render, staticRenderFns } from "./KanbanDragDrop.vue?vue&type=template&id=33d30598&scoped=true&"
import script from "./KanbanDragDrop.vue?vue&type=script&lang=js&"
export * from "./KanbanDragDrop.vue?vue&type=script&lang=js&"
import style0 from "./KanbanDragDrop.vue?vue&type=style&index=0&id=33d30598&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d30598",
  null
  
)

export default component.exports